import { Dictionary } from '../../types';

export default {
    locale: 'faIR',
    entries: {
        'maskan-bank': 'بانکداری متمرکز بانک مسکن',
        'stack-trace': 'ردیابی پشته',
        search: 'جستجو',
        refresh: 'بازنشانی',
        close: 'بستن',
        cancel: 'انصراف',
        save: 'ذخیره',
        edit: 'ویرایش',
        show: 'نمایش',

        'unauthorized-error-message': 'شما مجوز لازم برای انجام این عملیات ندارید!',

        'grid-header-row': 'ردیف',
        'grid-header-operation': 'عملیات',
        'grid-caption-add-button': 'اضافه',
        'grid-caption-new-button': 'جدید',
        'grid-caption-refresh-button': 'بازیابی',
        'grid-caption-filter-button': 'فیلتر',
        'grid-caption-reset-button': 'حذف فیلترها',
        'grid-delete-confirmDialog-header': 'حذف رکورد',
        'grid-delete-header': 'حذف',
        'grid-action-header': 'عملیات بیشتر',
        'grid-edit-header': 'ویرایش',
        'grid-show-header': 'نمایش',
        'grid-delete-confirmDialog-yes': 'بلی',
        'grid-delete-confirmDialog-no': 'خیر',
        'grid-column-type-boolean-true': 'بلی',
        'grid-column-type-boolean-false': 'خیر',
        'grid-paging-row': 'سطر',
        'grid-paging-from': 'از',
        'grid-paging-perPageItem': 'تعداد سطر در صفحه',
        'grid-paging-itemNotFound': 'رکوردی یافت نشد',
        'grid-row-number': 'ردیف',

        dataViewEmptyMessage: 'رکوردی یافت نشد',

        'confirmDialog-default-message': 'آیا مطمئن هستید؟',

        required: 'فیلد مورد نظر نمی تواند خالی باشد',
        minlength: 'عبارت وارد شده نباید کمتر از {0} کاراکتر باشد',
        maxlength: 'عبارت وارد شده نباید بیشتر از {0} کاراکتر باشد',
        pattern: 'فرمت وارد شده صحیح نمی باشد',

        'mcbCompare~': '{0} می بایست {1} {2} باشد!',
        'equal-to': 'مساوی با',
        'not-equal': 'مخالف',
        'equal-value-equal-type': 'مقدار و نوعش مساوی با',
        'not-equal-value-not-equal-type': 'مقدار و نوعش مخالف',
        greater: 'بزرگتر از',
        less: 'کوچکتر از',
        'greater-or-equal': 'بزرگتر مساوی',
        'less-or-equal': 'کوچکتر مساوی',

        'dropdown-boolean-default': 'انتخاب کنید',
        'dropdown-boolean-yes': 'بلی',
        'dropdown-boolean-no': 'خیر',

        'login-user-name': 'نام کاربری',
        'login-password': 'کلمه ی عبور',

        'login-enter': 'ورود',
        'login-exit': 'خروج',

        'change-password': 'تغییر کلمه عبور',
        'change-password-btn': 'تغییر',
        'change-password-Previous': 'کلمه عبور قبلی',
        'change-password-new': 'کلمه عبور جدید',
        'change-password-repeat-new': 'تکرار کلمه عبور جدید',

        'change-password-dont-same': 'کلمه ی عبور جدید برابر با تکرار کلمه عبور جدید نیست!',

        'changing-password': 'تغییر پسورد',
        messages: 'پیغام ها',
        notifications: 'اطلاعیه',

        'footer-accept': 'تایید',
        'footer-cancel': 'انصراف',

        'slideMenu-back': 'بازگشت',

        error: 'خطا',
        warn: 'اخطار',
        info: 'اطلاعات',
        success: 'موفقیت',

        'unknown-error': 'خطای ناشناخته!',
        'unknown-message': 'بدون توضیحات!',

        'form-dialog-cancel': 'انصراف',
        'form-dialog-register': 'ثبت',
        'form-dialog-insert': 'درج',

        'growl-read': 'خواندم',

        'table-caption-cancel': 'انصراف',
        'table-caption-select': 'انتخاب',

        'parameter-autocomplete-header-code': 'کد',
        'parameter-autocomplete-header-name': 'عنوان',

        'table-row-notSelected': 'هیچ سطری انتخاب نشده است',
        'menu-Item-open': 'باز کردن منوی ساید بار',
        'menu-user-open': 'باز کردن منوی پروفایل',

        'validation-err-required': 'الزامی',
        'validation-err-min': 'حداقل {0}',
        'validation-err-max': 'حداکثر {0}',
        'validation-err-minlength': 'حداقل {0} کاراکتر',
        'validation-err-maxlength': 'حداکثر {0} کاراکتر',
        'validation-err-email': 'ایمیل نامعتبر است',
        'validation-err-invalid-national-code': 'کد ملی نامعتبر است',
        'validation-err-invalid-mobile-number': 'شماره موبایل نامعتبر است',
        'validation-err-invalid-phone-number': 'شماره تلفن نامعتبر است',
        'validation-err-invalid-website': 'وب سایت نامعتبر است',
        'validation-err-invalid-date': 'تاریخ نامعتبر است',
        'validation-err-unknown': 'نامعتبر',
        'validation-err-title': 'موارد زیر را کنترل نمایید',
        'validation-err-pattern': 'نامعتبر',
        'http-err-common': 'خطایی رخ داده - شماره خطا : ',
        'http-err': 'خطا',
        'http-err-service-unavailable': 'سرویس در دسترسی نمیباشد',
        'http-err-unhandled': 'خطای ناشناخته رخ داده است : ',
        'http-err-unauthorized-title': 'خطای دسترسی',
        'http-err-unauthorized-description': 'به این سرویس دسترسی ندارید',
        saved: 'ذخیره شد',

        'money-input-rial': 'ریال',
        'money-input-toman': 'تومان',
        'money-input-dollar': 'دلار',
        'money-input-euro': 'یورو',
        invalid: 'نامعتبر',
        return: 'بازگشت',
        'workflow-title': 'گردش کار',
        'state-title': 'گام',
        'workflow-instance-id': 'شناسه',
        'referrer-title': 'ارجاع دهنده',
        'changes-are-not-saved': 'تغییرات ذخیره نشده است. از ترک این صفحه اطمینان دارید؟',

        'stack-trace-title': 'جزئیات خطا',
        'services': 'سرویس ها',
        'permission': 'سطح دسترسی',
        'inequalPassword': 'کلمه عبور و تکرار آن یکسان نیستند',
        newPassword: 'کلمه عبور جدید',
        currentPassword: 'کلمه عبور فعلی',
        newPasswordConfirm: 'تکرار کلمه عبور جدید',
        userName: 'نام کاربری',
        password: 'کلمه عبور',
        captcha: 'کد امنیتی',
        organization: 'سازمان'
    }
} as Dictionary;
